import axios from "axios";
import { server } from "../../server";
import { toast } from 'react-toastify';
import { getCoordinatesFromPin } from '../../utils/pincode';
// Load user
export const loadUser = () => async (dispatch) => {
  try {
    dispatch({
      type: "LoadUserRequest",
    });
    const { data } = await axios.get(`${server}/user/getuser`, {
      withCredentials: true,
    });
    dispatch({
      type: "LoadUserSuccess",
      payload: data.user,
    });
  } catch (error) {
    dispatch({
      type: "LoadUserFail",
      payload: error.response.data.message,
    });
  }
};

// Load seller
export const loadSeller = () => async (dispatch) => {
  try {
    dispatch({
      type: "LoadSellerRequest",
    });
    const { data } = await axios.get(`${server}/shop/getSeller`, {
      withCredentials: true,
    });
    dispatch({
      type: "LoadSellerSuccess",
      payload: data.seller,
    });
  } catch (error) {
    dispatch({
      type: "LoadSellerFail",
      payload: error.response.data.message,
    });
  }
};

// User update information
export const updateUserInformation =
  (name, email, phoneNumber, gstNumber, billingAddress, zipCode, password) => async (dispatch) => {
    try {
      dispatch({
        type: "updateUserInfoRequest",
      });

      const { data } = await axios.put(
        `${server}/user/update-user-info`,
        {
          name,
          email,
          phoneNumber,
          gstNumber,
          password,
          billingAddress,
          zipCode,
        },
        {
          withCredentials: true,
          headers: {
            "Access-Control-Allow-Credentials": true,
          },
        }
      );

      dispatch({
        type: "updateUserInfoSuccess",
        payload: data.user,
      });
    } catch (error) {
      dispatch({
        type: "updateUserInfoFailed",
        payload: error.response.data.message,
      });
    }
  };

// Update user address
export const updateUserAddress =
  (country, city, address1, address2, zipCode, addressType) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "updateUserAddressRequest",
      });

      const { data } = await axios.put(
        `${server}/user/update-user-addresses`,
        {
          country,
          city,
          address1,
          address2,
          zipCode,
          addressType,
        },
        { withCredentials: true }
      );

      dispatch({
        type: "updateUserAddressSuccess",
        payload: {
          successMessage: "User address updated successfully!",
          user: data.user,
        },
      });
    } catch (error) {
      dispatch({
        type: "updateUserAddressFailed",
        payload: error.response.data.message,
      });
    }
  };

// Delete user address
export const deleteUserAddress = (id) => async (dispatch) => {
  try {
    dispatch({
      type: "deleteUserAddressRequest",
    });

    const { data } = await axios.delete(
      `${server}/user/delete-user-address/${id}`,
      { withCredentials: true }
    );

    dispatch({
      type: "deleteUserAddressSuccess",
      payload: {
        successMessage: "User address deleted successfully!",
        user: data.user,
      },
    });
  } catch (error) {
    dispatch({
      type: "deleteUserAddressFailed",
      payload: error.response.data.message,
    });
  }
};

// Get all users --- admin
export const getAllUsers = () => async (dispatch) => {
  try {
    dispatch({
      type: "getAllUsersRequest",
    });

    const { data } = await axios.get(`${server}/user/admin-all-users`, {
      withCredentials: true,
    });

    dispatch({
      type: "getAllUsersSuccess",
      payload: data.users,
    });
  } catch (error) {
    dispatch({
      type: "getAllUsersFailed",
      payload: error.response.data.message,
    });
  }
};

export const getSavedCarts = () => async (dispatch) => {
  try {
    dispatch({
      type: "getSavedCartsRequest",
    });

    const { data } = await axios.get(`${server}/user/saved-carts`, {
      withCredentials: true,
    });

    dispatch({
      type: "getSavedCartsSuccess",
      payload: data.savedCarts,
      user: data.user,
    });
  } catch (error) {
    dispatch({
      type: "getSavedCartsFailed",
      payload: error.response.data.message,
    });
  }
};

// Save cart
export const saveCart = (bundleName, items) => async (dispatch) => {
  try {
    dispatch({ type: "saveCartRequest" });

    const { data } = await axios.post(`${server}/user/save-cart`, { bundleName, items }, {
      withCredentials: true,
    });

    // Dispatch the new cart directly to the state without fetching all saved carts again
    dispatch({
      type: "saveCartSuccess",
      payload: data.savedCart,  // Only return the newly saved cart
    });
  } catch (error) {
    dispatch({
      type: "saveCartFailed",
      payload: error.response.data.message,
    });
  }
};


// Delete saved cart
export const deleteSavedCart = (id) => async (dispatch) => {
  try {
    dispatch({ type: "deleteSavedCartRequest" });

    await axios.delete(`${server}/user/delete-saved-cart/${id}`, {
      withCredentials: true,
    });

    // Directly remove the deleted cart from the state
    dispatch({
      type: "deleteSavedCartSuccess",
      payload: id,  // Only pass the ID of the deleted cart
    });
  } catch (error) {
    dispatch({
      type: "deleteSavedCartFailed",
      payload: error.response.data.message,
    });
  }
};




export const repeatOrder = (items) => async (dispatch) => {
  try {
    const { data } = await axios.post(`${server}/user/repeat-order`, { items });
    dispatch({ type: "RepeatOrderSuccess", payload: data.items });
  } catch (error) {
    dispatch({ type: "RepeatOrderFail", payload: error.response.data.message });
  }
};

// Action to set user pin code
export const setUserPinCodeAction = (pinCode) => async (dispatch) => {
  try {
    const coordinates = await getCoordinatesFromPin(pinCode);
    dispatch({
      type: 'setUserPinCode',
      payload: { pinCode, coordinates },
    });
    localStorage.setItem('userPinCode', pinCode);
    localStorage.setItem('userCoordinates', JSON.stringify(coordinates));
    toast.success('Pin code set successfully');
  } catch (error) {
    toast.error('Invalid Pin code');
    throw error;
  }
};


// Action to clear user pin code
export const clearUserPinCodeAction = () => (dispatch) => {
  dispatch({
    type: 'clearUserPinCode',
  });
  localStorage.removeItem('userPinCode');
  localStorage.removeItem('userCoordinates');
};